import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";

const DownloadTypesSelect = (
    {
        prefix = "", multiple = false,
        disabled = false,
        onChange,
        value,
        defaultValue
    }
) => {
    const [_Tc] = useTranslation("choices");
    const selectProps = {};

    if (value !== undefined) {
        selectProps.value = value;
    } else if (defaultValue !== undefined) {
        selectProps.defaultValue = defaultValue;
    } else {
        selectProps.defaultValue = "";
    }
    if(onChange !== undefined) {
       selectProps.onChange = onChange;
    }


    return (
        <Form.Select
            aria-label="Selector de tipo de descarga"
            name={prefix + "download_type"}
            disabled={disabled}
            {...selectProps}
        >
            <option value="">{_Tc("labels.all")}</option>
            <option value="re">{_Tc("downloads.re")}</option>
            <option value="la">{_Tc("downloads.la")}</option>
            <option value="de">{_Tc("downloads.de")}</option>
            <option value="ea">{_Tc("downloads.ea")}</option>
            <option value="fr">{_Tc("downloads.fr")}</option>
            <option value="ot">{_Tc("downloads.ot")}</option>
        </Form.Select>
    )

}
export default DownloadTypesSelect